// extracted by mini-css-extract-plugin
export default {"image-container":"imageitem_image-container__DWqan","image":"imageitem_image__MMbd0"};